<template lang="pug">

    tr
        td {{ supplierModel.name }}
        td {{ validUntil }}
        td(v-for='variantModel in variantModels')
            input(
                type='checkbox'
                v-bind:disabled='hasPersistedOfferModelForVariantId(variantModel.id)'
                v-bind:checked='hasOfferModelForVariantId(variantModel.id)'
                v-on:change="onOffersChange($event.target.checked, variantModel.id)"
            )
        td.right.aligned
            button.ui.mini.icon.button(
                v-if="value.id === undefined"
                v-tooltip='"Job entfernen"'
                v-on:click="deleteJob()"
            )
                i.class.remove.icon

</template>

<script>
    import * as R from 'ramda'
    import fecha from 'fecha'

    //noinspection JSUnusedGlobalSymbols
    export default {

        computed: {

            validUntil() {
                return R.ifElse(

                    // Wenn Datum Nummer ist
                    R.is(Number),

                    // Datum formatieren
                    R.curryN(2, fecha.format)(R.__, 'DD.MM.YYYY'),

                    // Standardmeldung
                    R.always('Datum nicht vorhanden')

                )(this.value.validUntil)
            }

        },

        methods: {

            deleteJob() {
                this.$emit('delete', this.value)
            },

            hasOfferModelForVariantId(variantId) {
                return R.compose(

                    // Pruefen ob Model gefunden wurden
                    R.is(Object),

                    // Angebot fuer Variante finden
                    R.find(R.propEq('variant', variantId))

                )(this.offerModels)
            },

            hasPersistedOfferModelForVariantId(variantId) {
                return R.compose(

                    // Preufen ob `id` besitzt
                    R.has('id'),

                    // ggf. zu leeren Objekt setzen
                    R.defaultTo({}),

                    // Angebotsmodels holen
                    R.find(R.propEq('variant', variantId))

                )(this.offerModels)
            },

            onOffersChange(isChecked, variantId) {
                const model = R.compose(

                    // Angebote in Job-Model setzen
                    R.assoc('offers', R.__, this.value),

                    R.ifElse(
                        R.equals(true),

                        // Angebot hinzufuegen
                        () => R.append({ job: this.value.id, variant: variantId }, this.value.offers),

                        // Angebot entfernen
                        () => R.reject(R.propEq('variant', variantId), this.value.offers)
                    ),

                )(isChecked)

                this.$emit('input', model)
            },

        },

        props: {

            offerModels: {
                type: Array,
                required: true
            },

            supplierModel: {
                type: Object,
                required: true
            },

            variantModels: {
                type: Array,
                required: true
            },

            value: {
                type: Object,
                required: true
            },
        }

    }

</script>
